import { z } from 'zod';
import { CapabilitiesSchema } from './capabilities';

export const PairRequestSchema = z.object({ capabilities: CapabilitiesSchema, hw_info: z.record(z.unknown()).optional() });
export const PairResponseSchema = z.object({ code: z.string(), poll_secret: z.string(), expires_at: z.string().datetime() });
export const PairPollResponseSchema = z.object({ status: z.enum(['pending', 'claimed']), token: z.string().optional() });
export const HeartbeatRequestSchema = z.object({
  app_version: z.string(),
  layout_version: z.number().int().nonnegative(),
  network: z.string(),
  battery: z.number().min(0).max(100).optional(),
  uptime_s: z.number().nonnegative(),
  capabilities: CapabilitiesSchema.optional(),
  /**
   * Block types the player saw in its deployed layout but could not render
   * (f10 P3.2). Additive + optional so older clients keep working; the admin
   * uses it to flag a screen whose device is silently skipping blocks.
   */
  unrenderable_blocks: z.array(z.string()).optional()
});
export const HeartbeatResponseSchema = z.object({ config_version: z.number().int().nonnegative(), has_commands: z.boolean() });
export const CommandSchema = z.object({
  id: z.string(),
  type: z.enum(['reload', 'clear_cache', 'update_config', 'restart', 'rotate_token', 'restart_app']),
  expires_at: z.string().datetime()
});
export const SubmissionBatchSchema = z.object({
  items: z.array(z.object({
    client_id: z.string().uuid(),
    layout_id: z.string(),
    payload: z.unknown(),
    submitted_at: z.string().datetime()
  }))
});
export const TouchRequestSchema = z.object({ x: z.number().int().nonnegative(), y: z.number().int().nonnegative(), frame_hash: z.string().min(1) });

export type PairRequest = z.infer<typeof PairRequestSchema>;
export type PairResponse = z.infer<typeof PairResponseSchema>;
export type PairPollResponse = z.infer<typeof PairPollResponseSchema>;
export type HeartbeatRequest = z.infer<typeof HeartbeatRequestSchema>;
export type HeartbeatResponse = z.infer<typeof HeartbeatResponseSchema>;
export type Command = z.infer<typeof CommandSchema>;
export type SubmissionBatch = z.infer<typeof SubmissionBatchSchema>;
export type TouchRequest = z.infer<typeof TouchRequestSchema>;